import * as i0 from '@angular/core';
import { Injectable, Inject, InjectionToken } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_BASE_HREF } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

class ApiService {
    constructor(m_baseHref, m_http) {
        this.m_baseHref = m_baseHref;
        this.m_http = m_http;
    }
    get(p_path, options) {
        //console.debug(`get called for ${p_path} with params: ${options && options.params ? options.params.toString() : ''}`);
        return this.m_http.get(`${this.m_baseHref}${p_path}`, options)
            .pipe(
        //tap(data => console.debug(`response for get ${p_path} with params: ${options && options.params ? options.params.toString() : ''}:\n`)),
        catchError((error, caught) => this.handleError(error)));
    }
    post(p_path, p_body = {}, options) {
        //console.debug(`POST called for ${this.m_baseHref}${p_path} with body: ${JSON.stringify(p_body)}`);
        return this.m_http.post(`${this.m_baseHref}${p_path}`, JSON.stringify(p_body), options).pipe(
        //tap(data => console.debug(`response for POST ${this.m_baseHref}${p_path} with params: ${JSON.stringify(p_body)}:\n`)),
        catchError((error, caught) => this.handleError(error)));
    }
    handleError(p_error) {
        console.error(`Error in ApiService ${p_error.status + " :" + p_error.message}`);
        return throwError(p_error);
    }
    static { this.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(i0.ɵɵinject(APP_BASE_HREF), i0.ɵɵinject(i1.HttpClient)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiService, factory: ApiService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }, { type: i1.HttpClient }]; }, null); })();

class OpenModelServletService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    doQuery(queryName, parameter) {
        let httpParams = this.objectToHttpParams(parameter);
        return this.apiService.get(`api/query/${queryName}`, { params: httpParams });
    }
    get(serviceName, methodName, parameter) {
        let httpParams = parameter instanceof HttpParams ? parameter : this.objectToHttpParams(parameter);
        return this.apiService.get(`api/srv/${serviceName}/${methodName}`, { params: httpParams });
    }
    post(serviceName, methodName, body) {
        return this.apiService.post(`api/srv/${serviceName}/${methodName}`, body);
    }
    buildLobUrl(queryName, parameter) {
        let httpParams = this.objectToHttpParams(parameter).toString();
        return `api/lob/${queryName}?${httpParams}`;
    }
    objectToHttpParams(obj) {
        let httpParams = new HttpParams();
        if (obj != null) {
            Object.keys(obj).forEach((key) => {
                if (obj[key] != undefined) {
                    if (Array.isArray(obj[key])) {
                        obj[key].forEach((element) => {
                            httpParams = httpParams.append(key, element.toString());
                        });
                    }
                    else if (obj[key] instanceof Date) {
                        httpParams = httpParams.set(key, obj[key].toISOString().slice(0, -1));
                    }
                    else {
                        httpParams = httpParams.set(key, obj[key].toString());
                    }
                }
            });
        }
        return httpParams;
    }
    static { this.ɵfac = function OpenModelServletService_Factory(t) { return new (t || OpenModelServletService)(i0.ɵɵinject(ApiService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OpenModelServletService, factory: OpenModelServletService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpenModelServletService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
                deps: [ApiService]
            }]
    }], function () { return [{ type: ApiService }]; }, null); })();

/**
 * Standardimplementation
 */
class SfxServletService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    get(serviceName, methodName, parameter) {
        let httpParams = this.objectToHttpParams(parameter);
        return this.apiService.get(`${serviceName}/${methodName}`, { params: httpParams });
    }
    post(serviceName, methodName, body) {
        return this.apiService.post(`${serviceName}/${methodName}`, body);
    }
    objectToHttpParams(obj) {
        let httpParams = new HttpParams();
        if (obj != null) {
            Object.keys(obj).forEach((key) => {
                if (obj[key] != undefined) {
                    httpParams = httpParams.set(key, obj[key].toString());
                }
            });
        }
        return httpParams;
    }
    static { this.ɵfac = function SfxServletService_Factory(t) { return new (t || SfxServletService)(i0.ɵɵinject(ApiService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SfxServletService, factory: SfxServletService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SfxServletService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiService }]; }, null); })();

const QUERY_INVOKER = new InjectionToken('query.invoker');

const SFX_SERVICE_INVOKER = new InjectionToken('sfx.service.invoker');

class Tlob {
}

/*
 * Public API Surface of e-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiService, OpenModelServletService, QUERY_INVOKER, SFX_SERVICE_INVOKER, SfxServletService, Tlob };
